<script>
  import ResetPasswordForm from '@core/components/auth/reset-password/reset-password-init-form';
  import NewPasswordForm from '@core/components/auth/reset-password/reset-password-new-password-form';

  export default {
    functional: true,
    components: { ResetPasswordForm, NewPasswordForm },
    methods: {},
    render(h) {
      const query_string = window.location.search;
      const url_params = new URLSearchParams(query_string);
      const email_code = url_params.get('email_code');
      const wrapper = node => {
        return h('section', { class: 'auth-page' }, [node]);
      };
      if (email_code) {
        const new_password_form = h(NewPasswordForm, {
          props: {
            email_code
          }
        });
        return wrapper(new_password_form);
      }
      return wrapper(h(ResetPasswordForm));
    }
  };
</script>

<style lang="scss">
  .reset-password-success {
    color: white;
    font-size: 16px;
    word-wrap: break-word;
  }
</style>
